module.exports = __webpack_public_path__ + "img/selected.11fd873f.png";